import React, { useEffect, useState } from 'react';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import CreditLineStatus from '../Common/CreditLineStatus';
import Warranties from './components/Warranties';
import { getUser } from 'lib/api';
import { RootState } from 'services/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { getCreditLineByProduct } from 'lib/api/creditLine';
import { showAlert } from 'lib/functions/utils';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';

const SGR = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const [isLoading, setIsLoading] = useState(true);
  const [creditLineData, setCreditLineData] = useState<any>(null);

  const fetchCreditLine = async () => {
    try {
      setIsLoading(true);
      const profile = await getUser(dispatch, { id: auth.user?.id });
      if (!profile) throw new Error('Profile not found');
      const businessIdentifier = profile.company.taxIdentifier;
      const response = await getCreditLineByProduct(
        dispatch,
        businessIdentifier,
        'sgr',
      );
      if (response) setCreditLineData(response);
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al obtener la línea de crédito');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCreditLine();
  }, []);

  if (isLoading) return <CenteredCircularProgress />;

  const getAvailableTabs = () => {
    const tabs = [
      {
        label: 'Línea de Crédito',
        component: <CreditLineStatus productId="sgr" />,
        index: 0,
      },
    ];

    if (creditLineData) {
      tabs.push({
        label: 'Garantías',
        component: <Warranties />,
        index: 1,
      });
    }

    return tabs;
  };

  const tabs = getAvailableTabs();

  return (
    <div>
      <EnhancedTab title="SGR" startValue={0} tabs={tabs} />
    </div>
  );
};

export default SGR;
